import { render, staticRenderFns } from "./CobranzaReport.vue?vue&type=template&id=accd5ee6&scoped=true"
import script from "./CobranzaReport.vue?vue&type=script&lang=js"
export * from "./CobranzaReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accd5ee6",
  null
  
)

export default component.exports